import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "../firebaseConfig";
import {
  collection,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";
import {
  FaPlay,
  FaCalendarAlt,
  FaClock,
} from "react-icons/fa";

const Video = () => {
  const [videos, setVideos] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState("all");
  const [loading, setLoading] = useState(true);
  const [hoveredId, setHoveredId] = useState(null);
const [hoveredCategory, setHoveredCategory] = useState(null);

const [currentPage, setCurrentPage] = useState(1);

const videosPerPage = 20;

  // ==========================================
  // CATEGORY LOAD
  // ==========================================
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const q = query(
          collection(db, "categories"),
          orderBy("order", "asc")
        );

        const snapshot = await getDocs(q);

        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setCategories(data);
      } catch (error) {
        console.error("Category load error:", error);
      }
    };

    fetchCategories();
  }, []);

  // ==========================================
  // VIDEO LOAD
  // ==========================================
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setLoading(true);

        const q = query(
          collection(db, "videos"),
          orderBy("timestamp", "desc")
        );

        const snapshot = await getDocs(q);

        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setVideos(data);
      } catch (error) {
        console.error("Video load error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  // ==========================================
  // CATEGORY FILTER
  // ==========================================
  const filteredVideos =
    activeCategory === "all"
      ? videos
      : videos.filter(
          (video) => video.category === activeCategory
        );

  // ==========================================
  // YOUTUBE THUMBNAIL
  // ==========================================
  const getYoutubeThumbnail = (url) => {
    if (!url) return "";

    let videoId = "";

    try {
      const parsed = new URL(url);

      // youtu.be/VIDEO_ID
      if (parsed.hostname.includes("youtu.be")) {
        videoId = parsed.pathname.substring(1);
      }

      // youtube.com/watch?v=VIDEO_ID
      else if (parsed.hostname.includes("youtube.com")) {
        videoId = parsed.searchParams.get("v") || "";

        // youtube.com/shorts/VIDEO_ID
        if (
          !videoId &&
          parsed.pathname.includes("/shorts/")
        ) {
          videoId =
            parsed.pathname.split("/shorts/")[1];
        }

        // youtube.com/embed/VIDEO_ID
        if (
          !videoId &&
          parsed.pathname.includes("/embed/")
        ) {
          videoId =
            parsed.pathname.split("/embed/")[1];
        }
      }
    } catch (error) {
      return "";
    }

    if (!videoId) return "";

    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  };

  // ==========================================
  // DATE FORMAT
  // ==========================================
  const formatDate = (timestamp) => {
    if (!timestamp) return "";

    try {
      return new Date(
        timestamp.seconds * 1000
      ).toLocaleDateString("bn-BD", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    } catch {
      return "";
    }
  };

  // ==========================================
  // TIME FORMAT
  // ==========================================
  const formatTime = (timestamp) => {
    if (!timestamp) return "";

    try {
      return new Date(
        timestamp.seconds * 1000
      ).toLocaleTimeString("bn-BD", {
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return "";
    }
  };

const totalPages = Math.ceil(
  filteredVideos.length / videosPerPage
);

const startIndex =
  (currentPage - 1) * videosPerPage;

const currentVideos = filteredVideos.slice(
  startIndex,
  startIndex + videosPerPage
);




  return (
  <div
    style={{
      maxWidth: "1400px",
      margin: "0 auto",
      padding: "20px",
    }}
  >

    {/* ==========================================
        HEADING
    ========================================== */}
    <div
      style={{
        borderLeft: "6px solid #d2202a",
        paddingLeft: "10px",
        marginBottom: "15px",
      }}
    >
      <h2
        style={{
          margin: 0,
          fontSize: "26px",
          color: "#222",
          fontWeight: "700",
        }}
      >
        ভিডিও
      </h2>
    </div>


    {/* ==========================================
        CATEGORY BUTTONS
    ========================================== */}
    <div
      className="video-category-bar"
      style={{
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
        gap: "8px",
        marginBottom: "25px",
        borderBottom: "1px solid #eee",
        paddingBottom: "15px",

        // Horizontal scrolling
        overflowX: "auto",
        overflowY: "hidden",
        whiteSpace: "nowrap",

        // Smooth scrolling
        scrollBehavior: "smooth",

        // Firefox scrollbar
        scrollbarWidth: "thin",

        // Prevent scrollbar থেকে layout নষ্ট হওয়া
        WebkitOverflowScrolling: "touch",
      }}
    >

      {/* ==========================================
          সর্বশেষ BUTTON
      ========================================== */}
      <button
        onClick={() => {
  setActiveCategory("all");
  setCurrentPage(1);
}}
        onMouseEnter={() => setHoveredCategory("all")}
        onMouseLeave={() => setHoveredCategory(null)}
        style={{
          flexShrink: 0,
          padding: "8px 16px",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",

          background:
            activeCategory === "all" ||
            hoveredCategory === "all"
              ? "#d2202a"
              : "#f1f1f1",

          color:
            activeCategory === "all" ||
            hoveredCategory === "all"
              ? "#fff"
              : "#333",

          fontWeight: "bold",
          fontSize: "15px",

          transform:
            hoveredCategory === "all"
              ? "translateY(-2px)"
              : "translateY(0)",

          boxShadow:
            hoveredCategory === "all"
              ? "0 3px 8px rgba(210,32,42,0.25)"
              : "none",

          transition: "all 0.2s ease",
        }}
      >
        সর্বশেষ
      </button>


      {/* ==========================================
          CATEGORY BUTTONS
      ========================================== */}
      {categories.map((cat) => (
        <button
          key={cat.id}
        onClick={() => {
  setActiveCategory(cat.name);
  setCurrentPage(1);
}}
          onMouseEnter={() => setHoveredCategory(cat.name)}
          onMouseLeave={() => setHoveredCategory(null)}
          style={{
            flexShrink: 0,
            padding: "8px 16px",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",

            background:
              activeCategory === cat.name ||
              hoveredCategory === cat.name
                ? "#d2202a"
                : "#f1f1f1",

            color:
              activeCategory === cat.name ||
              hoveredCategory === cat.name
                ? "#fff"
                : "#333",

            fontWeight: "bold",
            fontSize: "15px",

            transform:
              hoveredCategory === cat.name
                ? "translateY(-2px)"
                : "translateY(0)",

            boxShadow:
              hoveredCategory === cat.name
                ? "0 3px 8px rgba(210,32,42,0.25)"
                : "none",

            transition: "all 0.2s ease",
          }}
        >
          {cat.name}
        </button>
      ))}
    </div>

      {/* ==========================================
          VIDEO GRID
      ========================================== */}
      {loading ? (
        <div
          style={{
            textAlign: "center",
            padding: "50px",
            color: "#777",
          }}
        >
          <div
            style={{
              width: "32px",
              height: "32px",
              border: "4px solid #eee",
              borderTop: "4px solid #d2202a",
              borderRadius: "50%",
              margin: "0 auto 15px",
              animation:
                "videoSpinner 1s linear infinite",
            }}
          />

          <div
            style={{
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            ভিডিও লোড হচ্ছে...
          </div>
        </div>
      ) : filteredVideos.length > 0 ? (

        <div
          className="video-grid"
          style={{
            display: "grid",

            // Desktop → 4 columns
            gridTemplateColumns:
              "repeat(4, minmax(0, 1fr))",

            gap: "25px 20px",
          }}
        >

         {currentVideos.map((video) => {

            const thumbnail =
              video.thumbnail ||
              getYoutubeThumbnail(
                video.youtubeUrl
              );

            return (
              <Link
                key={video.id}
                to={`/video/${video.id}`}
                style={{
                  textDecoration: "none",
                  color: "#222",
                  display: "block",

                  background: "#fff",

                  borderRadius: "7px",

                  transition:
                    "transform 0.2s ease, background 0.2s ease",

                  transform:
                    hoveredId === video.id
                      ? "translateY(-2px)"
                      : "translateY(0)",
                }}

                onMouseEnter={() =>
                  setHoveredId(video.id)
                }

                onMouseLeave={() =>
                  setHoveredId(null)
                }
              >

                {/* ==================================
                    THUMBNAIL
                ================================== */}
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    aspectRatio: "16 / 9",

                    overflow: "hidden",

                    borderRadius: "6px",

                    background: "#eee",
                  }}
                >

                  {thumbnail ? (
                    <img
                      src={thumbnail}
                      alt={video.title}
                      loading="lazy"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",

                        transition:
                          "transform 0.3s ease",

                        transform:
                          hoveredId === video.id
                            ? "scale(1.03)"
                            : "scale(1)",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#999",
                        fontSize: "14px",
                      }}
                    >
                      কোনো ছবি নেই
                    </div>
                  )}

                  {/* ==================================
                      PLAY BUTTON
                  ================================== */}
                  <div
                    style={{
                      position: "absolute",
                      left: "50%",
                      top: "50%",

                      transform:
                        "translate(-50%, -50%)",

                      width: "48px",
                      height: "48px",

                      borderRadius: "50%",

                      background:
                        "rgba(210,32,42,0.95)",

                      color: "#fff",

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",

                      fontSize: "18px",

                      boxShadow:
                        "0 3px 10px rgba(0,0,0,0.25)",
                    }}
                  >
                    <FaPlay />
                  </div>

                </div>

                {/* ==================================
                    TITLE
                ================================== */}
                <h3
                  style={{
                    margin: "10px 0 6px",

                    fontSize: "18px",

                    lineHeight: "1.45",

                    fontWeight: "bold",

                    color:
                      hoveredId === video.id
                        ? "#4169E1"
                        : "#222",

                    transition:
                      "color 0.2s ease",
                  }}
                >
                  {video.title}
                </h3>

                {/* ==================================
                    DATE + TIME
                ================================== */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",

                    color: "#777",

                    fontSize: "12px",

                    marginTop: "4px",
                  }}
                >

                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <FaCalendarAlt size={11} />

                    {formatDate(
                      video.timestamp
                    )}
                  </span>

                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <FaClock size={11} />

                    {formatTime(
                      video.timestamp
                    )}
                  </span>

                </div>

              </Link>
            );
          })}


{totalPages > 1 && (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "6px",
      marginTop: "35px",
      flexWrap: "wrap",
    }}
  >
    {Array.from(
      { length: totalPages },
      (_, index) => index + 1
    ).map((page) => (
      <button
        key={page}
        type="button"
        onClick={() => {
          setCurrentPage(page);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
        style={{
          minWidth: "38px",
          height: "38px",
          padding: "0 10px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "15px",
          fontWeight: "bold",

          background:
            currentPage === page
              ? "#d2202a"
              : "#fff",

          color:
            currentPage === page
              ? "#fff"
              : "#333",

          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          if (currentPage !== page) {
            e.currentTarget.style.background = "#d2202a";
            e.currentTarget.style.color = "#fff";
          }
        }}
        onMouseLeave={(e) => {
          if (currentPage !== page) {
            e.currentTarget.style.background = "#fff";
            e.currentTarget.style.color = "#333";
          }
        }}
      >
        {page}
      </button>
    ))}
  </div>
)}

        </div>

      ) : (

        /* ==========================================
           NO VIDEO
        ========================================== */
        <div
          style={{
            textAlign: "center",
            padding: "60px 20px",
            color: "#777",
          }}
        >
          <div
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "5px",
            }}
          >
            কোনো ভিডিও পাওয়া যায়নি।
          </div>

          <div
            style={{
              fontSize: "14px",
            }}
          >
            এই ক্যাটাগরিতে বর্তমানে কোনো ভিডিও নেই।
          </div>
        </div>
      )}

      {/* ==========================================
          RESPONSIVE + SCROLLBAR CSS
      ========================================== */}
      <style>{`

        /* Category scrollbar */
        .video-category-bar::-webkit-scrollbar {
          height: 5px;
        }

        .video-category-bar::-webkit-scrollbar-track {
          background: transparent;
        }

        .video-category-bar::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 10px;
        }

        .video-category-bar::-webkit-scrollbar-thumb:hover {
          background: #999;
        }

        /* Tablet */
        @media (max-width: 1100px) {
          .video-grid {
            grid-template-columns: repeat(3, 1fr) !important;
          }
        }

        /* Small tablet */
        @media (max-width: 900px) {
          .video-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }

        /* Mobile */
        @media (max-width: 600px) {
          .video-grid {
            grid-template-columns: 1fr !important;
            gap: 20px !important;
          }
        }

        /* Spinner */
        @keyframes videoSpinner {
          0% {
            transform: rotate(0deg);
          }

          100% {
            transform: rotate(360deg);
          }
        }

      `}</style>

    </div>
  );
};

export default Video;